import { Quote } from "@/pages/Quotes/types";

export const STORAGE_KEY = 'cached-quotes';
export const CC_STORAGE_KEY = 'cached-cc-quote';

// Get initial quote from localStorage
export const getQuoteFromLocalStorage = (accountId: string, isCommandCenterProducts: boolean): Quote | undefined => {
    if (isCommandCenterProducts) {
        return JSON.parse(localStorage.getItem(CC_STORAGE_KEY) || '{}');
    }
    const savedQuotes = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    const savedQuote = savedQuotes[accountId];

    if (!savedQuote) {
        return undefined;
    }
    return savedQuote;
};

export const cacheQuoteToLocalStorage = (accountId: string, quote: Quote, isCommandCenterProducts?: boolean) => {
    if (isCommandCenterProducts) {
        localStorage.setItem(CC_STORAGE_KEY, JSON.stringify(quote));
    } else {
        const savedQuotes = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        savedQuotes[accountId] = quote;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(savedQuotes));
    }
};
